import { Container, Nav, Navbar } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import './MainNavbar.scss';
import { ReactComponent as ThinnectSmallLogo } from './../assets/icons/NN_logo.svg';
import { NavLink } from 'react-router-dom';

type Props = {
	windowSize: { width: number | undefined; height: number | undefined };
	isLoggedIn: boolean;
	emitLogout: () => void;
};

const MainNavbar = ({ windowSize, isLoggedIn, emitLogout }: Props) => {
	const [toggleNavbar, setToggleNavbar] = useState<boolean>(false);

	useEffect(() => {
		if (windowSize.width && windowSize.width > 576) {
			document.body.style.overflowY = '';
			setToggleNavbar(false);
		}
	}, [windowSize]);

	function toggleNavbarStatus(status: boolean): void {
		if (status !== toggleNavbar) {
			document.body.style.overflowY = !toggleNavbar ? 'hidden' : '';
			setToggleNavbar(status);
		}
	}

	function logout() {
		toggleNavbarStatus(false);
		emitLogout();
	}

	return (
		<Navbar expand="sm" variant="light" expanded={toggleNavbar} collapseOnSelect={true}>
			<Container fluid>
				<Navbar.Brand>
					<ThinnectSmallLogo className="thinnect-small-logo" />
				</Navbar.Brand>
				{isLoggedIn && (
					<Navbar.Toggle
						aria-controls="navbar-nav"
						onClick={() => toggleNavbarStatus(!toggleNavbar)}
					/>
				)}
				{isLoggedIn && (
					<Navbar.Collapse id="navbar-nav">
						<Nav className="ms-sm-auto">
							<Nav.Link onClick={() => toggleNavbarStatus(false)} as={NavLink} to="/dashboard">
								All rooms
							</Nav.Link>
							<Nav.Link
								disabled
								onClick={() => toggleNavbarStatus(false)}
								href="https://thinnect.com"
							>
								Info
							</Nav.Link>
							<Nav.Link onClick={() => logout()}>Log out</Nav.Link>
						</Nav>
					</Navbar.Collapse>
				)}
			</Container>
		</Navbar>
	);
};

export default MainNavbar;
